<div *ngIf="descriptor" [ngSwitch]="descriptor.controlType">

    <!-- handling text input -->
    <vedrax-input *ngSwitchCase="'input'" [descriptor]="descriptor" [control]="control"></vedrax-input>

    <!-- handling select -->
    <vedrax-select *ngSwitchCase="'select'" [descriptor]="descriptor" [control]="control" (isReady)=checkIfOptionsAvailable($event)></vedrax-select>

    <!-- handling select autocomplete component -->
    <vedrax-select-autocomplete *ngSwitchCase="'selectAutocomplete'" [descriptor]="descriptor" [control]="control" (isReady)=checkIfOptionsAvailable($event)></vedrax-select-autocomplete>

    <!-- handling datepicker -->
    <vedrax-datepicker *ngSwitchCase="'datepicker'" [descriptor]="descriptor" [control]="control">
    </vedrax-datepicker>

    <!-- handling checkbox -->
    <vedrax-checkbox *ngSwitchCase="'checkbox'" [descriptor]="descriptor" [control]="control">
    </vedrax-checkbox>

    <!-- handling radio button -->
    <vedrax-radio *ngSwitchCase="'radioButton'" [descriptor]="descriptor" [control]="control"></vedrax-radio>

</div>
